import React, { useState, useEffect } from "react";
import "./Footer.css";
import "../Css/style.css";
import { Link, NavLink } from "react-router-dom";
import { useAppContext } from "../../contexts/AppContext";
import axios from "axios";
import parse from "html-react-parser";

function Footer() {
  const { backendUrl, translate, getImageUrl } = useAppContext();
  const companyRoute = "/company";
  const socialMediaRoute = "/socialMedia";
  const callUsRoute = "/CallUs";
  const emailRoute = "/Email";
  const adressRoute = "/Adress";
  const serviceRoute = "/ServiceList";

  const [company, setCompany] = useState([]);
  const [socialMedia, setSocialMedia] = useState([]);
  const [contacts, setContacts] = useState(null);
  const [email, setEmail] = useState(null);
  const [adress, setAdress] = useState(null);
  const [serviceslist, setServicesList] = useState([]);
  const year = new Date().getFullYear();

  useEffect(() => {
    const fetchdata = async () => {
      try {
        const [companyRes, serviceRes, emailRes, adressRes, contactsRes, socialRes] = await Promise.all([
          axios.get(`${backendUrl}${companyRoute}`),
          axios.get(`${backendUrl}${serviceRoute}`),
          axios.get(`${backendUrl}${emailRoute}`),
          axios.get(`${backendUrl}${adressRoute}`),
          axios.get(`${backendUrl}${callUsRoute}`),
          axios.get(`${backendUrl}${socialMediaRoute}`)
        ]);

        if (Array.isArray(companyRes?.data) && companyRes.data.length > 0) setCompany(companyRes.data);
        if (Array.isArray(serviceRes?.data)) setServicesList(serviceRes.data);
        if (Array.isArray(emailRes?.data) && emailRes.data.length > 0) setEmail(emailRes.data[0]);
        if (Array.isArray(adressRes?.data) && adressRes.data.length > 0) setAdress(adressRes.data[0]);
        if (Array.isArray(contactsRes?.data) && contactsRes.data.length > 0) setContacts(contactsRes.data[0]);
        if (Array.isArray(socialRes?.data)) setSocialMedia(socialRes.data);
      } catch (error) {
        console.error("Error fetching footer data:", error);
      }
    };
    fetchdata();
  }, [backendUrl]);

  const handleNavClick = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <footer className="footer-container">
      <div className="footer-content">
        {/* Company Info Section */}
        <div className="footer-element">
          {company.map((comp, index) => (
            <div key={index} className="d-flex flex-column">
              <div className="company-logo">
                <Link to="/">
                  {comp.images?.[0] && (
                    <img
                      className="company-logo-img"
                      src={getImageUrl(comp.images[0])}
                      alt="logo"
                    />
                  )}
                </Link>
              </div>
              <div className="company-description">
                {comp.title && parse(translate(comp.title))}
              </div>
            </div>
          ))}
          <div className="social-media-container">
            {socialMedia.map((item, index) => {
              const link = item?.link || "#";
              const absoluteLink = (link.startsWith("http://") || link.startsWith("https://")) 
                ? link 
                : `https://${link}`;
              
              return (
                <div key={index} className="social-midia-icon-container">
                  <a href={absoluteLink} target="_blank" rel="noopener noreferrer">
                    {item.images?.[0] && (
                      <img src={getImageUrl(item.images[0])} alt="social" />
                    )}
                  </a>
                </div>
              );
            })}
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-element">
          <b>{parse(translate("Quick Links"))}</b>
          <div className="nav-item">
            <NavLink className="nav-link" to="/" onClick={() => handleNavClick("home")}>
              {parse(translate("Home"))}
            </NavLink>
            <NavLink className="nav-link" to="#services" onClick={() => handleNavClick("services")}>
              {parse(translate("Services"))}
            </NavLink>
            <NavLink className="nav-link" to="#products" onClick={() => handleNavClick("products")}>
              {parse(translate("Our Team"))}
            </NavLink>
            <NavLink className="nav-link" to="#portfolio" onClick={() => handleNavClick("portfolio")}>
              {parse(translate("Gallery"))}
            </NavLink>
          </div>
        </div>

        {/* Services Section */}
        <div className="footer-element">
          <b>{parse(translate("Services"))}</b>
          <div className="nav-item">
            {serviceslist.slice(0, 4).map((service) => (
              <Link key={service.id} to="/services" className="nav-link">
                <span className="d-inline-flex align-items-start">
                  <i className="bi bi-chevron-right me-2" style={{ fontSize: "16px" }}></i>
                  {parse(translate(service.title))}
                </span>
              </Link>
            ))}
          </div>
        </div>

        {/* Contact Info Section */}
        <div className="footer-element">
          <b>{parse(translate("Contact Us"))}</b>
          <div className="nav-item gap-3 mt-2">
            {adress?.location && (
              <div className="contact-info-item">
                <i className="bi bi-geo-alt-fill"></i>
                <span>{parse(translate(adress.location))}</span>
              </div>
            )}
            {contacts?.mobile && (
              <div className="contact-info-item">
                <i className="bi bi-telephone-fill"></i>
                <span>{contacts.mobile}</span>
              </div>
            )}
            {email?.email && (
              <div className="contact-info-item">
                <i className="bi bi-envelope-fill"></i>
                <span>{email.email}</span>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Copyright Bar */}
      <div className="copy-right">
        <div className="d-flex align-items-center">
          <strong>&copy; {year} &nbsp;</strong>
          <span>
            {company[0]?.title && parse(translate(company[0].title))}
          </span>
        </div>
        <div className="powered-by">
          {parse(translate("Powered by"))}{" "}
          <Link target="_blank" to="https://www.lulsoft.com" className="text-decoration-none text-dark fw-bold">
            {parse(translate("LulSoft"))}
          </Link>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
